<noticemail-modal>
                <div id="{ props.modalId }" class="modal js-modal">
                    <div class="modal__bg js-modal-close"></div>
                    <div class="modal__content modal_filter">
                        <div class="modal__content_inner">
                            <h2 class="modal_title">メールアドレス編集</h2>
                            
                            <form action="" class="form_filter">
                                <div class="url_wrap address-url">
                                    <input type="text" name="addr" class="url-input" value="{state.item.mail}">
                                </div><!--/.url_wrap-->
                                
                            </form><!--/.form_filter	-->   
                            
                            <button class="button button-primary" type="button" value="更新する" onclick="{ (e) => edit(e) }">更新する</button>
                        </div><!--/.modal__content_inner-->
                        <a class="btn_close_modal js-modal-close" onclick="{ onClose }" style="cursor:pointer"><img src="/assets/img/common/icn_close_modal.svg" alt="閉じる"></a>
                    </div><!--modal__content-->
                </div><!--modal-->

  <script>
    export default {
        onBeforeMount(){
            this.api = this.props.api;
            this.api.on('item.set', (item) => {
                console.log(item);
                this.state.item = item;
                this.update();
            });
        },
        state: {
            item: {}
        },
        onClose(e) {
            window.$(this.$(`#${this.props.modalId}`)).fadeOut(100);
        },
        edit(e) {
            let input = this.root.querySelector('input[name=addr]');
            this.api.edit(this.state.item.id, input.value);
            this.onClose();
        }
    };
  </script>
</noticemail-modal>
